export default __webpack_public_path__ + "media/Pages/pickups/assets/techno_logo_white-d1873b6daad6faeda2a158060c84ee2f.svg";